// globalReportFiltersReducer.js

import { globalReportFiltersTypes } from "../types/globalReportFiltersTypes";
import {
    DATATYPE_RESDATE,
    DEFAULT_COMPARISON,
    DISPLAY_ELEMENT_HELPER,
    GROUP_COUNTRIES,
    GROUP_DATE_DAY,
    GROUP_DATE_MONTH,
    GROUP_DATE_YEAR,
    PRESET_ARRIVAL_DEFAULT,
    PRESET_LAST_YEAR,
    PRESET_MONTH_TO_DATE,
    PRESET_RESDATE_DEFAULT,
    PresetDates,
} from "../helpers/filters";
// import { MAX_DATE, MIN_DATE } from "../helpers/dates";

const globalReportFiltersInitial = {
    dataType: DATATYPE_RESDATE,
    ...PresetDates(PRESET_MONTH_TO_DATE),
    presetDate: PRESET_MONTH_TO_DATE, // If not "Custom", it will ignore from and to. If custom, it will take from and to values
    presetArrivalDate: PRESET_ARRIVAL_DEFAULT, // If not "Custom", it will ignore from and to. If custom, it will take from and to values
    presetResDate: PRESET_RESDATE_DEFAULT, // If not "Custom", it will ignore from and to. If custom, it will take from and to values
    ...(() => {
        const { fromDay, toDay } = PresetDates(PRESET_ARRIVAL_DEFAULT);
        return { fromArrivalDay: fromDay, toArrivalDay: toDay };
    })(),
    ...(() => {
        const { fromDay, toDay } = PresetDates(PRESET_RESDATE_DEFAULT);
        return { fromResDateDay: fromDay, toResDateDay: toDay };
    })(),
    filters: {
        Cancellations: "included",
        Countries: [],
        Offers: [],
        Rooms: [],
        Types: [],
        VoucherNames: [],
        Comparison: DEFAULT_COMPARISON,
        ComparisonCustom: { ...PresetDates(PRESET_LAST_YEAR) },
    },
    groupBy: [
        GROUP_COUNTRIES,
        GROUP_DATE_YEAR,
        GROUP_DATE_MONTH,
        GROUP_DATE_DAY,
    ],
    fieldsOrder: [
        // These will be the first ones
        "revenueTotal",
        "revenueRoom",
        "revenueExtras",
        "revenueVouchers",

        "bookingsTotal",
        "roomNightsTotal",
        "bookingsCancelled",
        "revenueRoomAndExtras",

        // "empty",

        // "ABWTotal",
        // "ALoSTotal",
        // "ADRTotal",
        // "empty",
    ],
    hideFields: [
        ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
            (e) =>
                ![
                    "ABWTotal",
                    "ALoSTotal",
                    "ADRTotal",
                    "bookingsCancelled",
                    "bookingsTotal",
                    "revenueTotal",
                    "roomNightsTotal",
                    "revenueRoom",
                    "revenueExtras",
                    "revenueRoomAndExtras",
                    "revenueVouchers",
                    "vouchersCount",
                ].includes(e)
        ),
        // "ABW",
        // "ABWCancelled",
        // // "ABWTotal",
        // "ALoS",
        // "ALoSCancelled",
        // // "ALoSTotal",
        // "ADR",
        // "ADRCancelled",
        // // "ADRTotal",
        // "bookings",
        // // "bookingsCancelled",
        // // "bookingsTotal",
        // "revenue",
        // "revenueCancelled",
        // // "revenueTotal",
        // "roomNights",
        // "roomNightsCancelled",
        // // "roomNightsTotal",
        // "revenueNett",
        // "revenueNettCancelled",
        // "revenueNettTotal",
        // "cancellationRate",
        // "vouchersCount",
        // "voucherMin",
        // "voucherMax",
    ],
    other: {
        excludeOtherExtrasIfFiltered: true, // This is to drop other extras in the same booking when there is a filter for extras
    },
};
export const globalReportFiltersReducer = (
    state = globalReportFiltersInitial,
    action
) => {
    switch (action.type) {
        case globalReportFiltersTypes.set:
            return { ...action.payload };

        case globalReportFiltersTypes.clean:
            return globalReportFiltersInitial;

        default:
            return state;
    }
};
